import { ChangeEvent, FocusEvent } from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { AutoComplete } from 'UIPackage/MainModule/components/AutoComplete';
import { TextInput, ITextInputProps } from 'UIPackage/MainModule/components/TextInput';

import { ILegalEntityAutoCompleteOption } from '../interfaces/ILegalEntityAutoCompleteOption';

type LegalEntityAutoCompleteFieldValue = ITextInputProps['value'];
export type ILegalEntityAutoCompleteFieldBasicProps = Omit<ITextInputProps, 'onChange'> &
  FieldProps<LegalEntityAutoCompleteFieldValue, FieldRenderProps<LegalEntityAutoCompleteFieldValue>> & {
    type?: 'half';
  };
type ILegalEntityAutoCompleteFieldProps = ILegalEntityAutoCompleteFieldBasicProps & {
  onChange?: (value: string) => void;
  onSelect?: (value: string) => () => void;
  options?: ILegalEntityAutoCompleteOption[];
};

export const LegalEntityAutoCompleteField = ({
  name,
  type,
  placeholder,
  clearable,
  disabled,
  validate,
  options,
  onChange,
  onSelect,
  onBlur,
  onClear,
  warning,
  success,
}: ILegalEntityAutoCompleteFieldProps) => (
  <Field name={name} onBlur={onBlur} validate={validate}>
    {({ input, meta }) => {
      const error = meta.touched && meta.error ? meta.error : undefined;

      function handleAutoCompleteChange(e: ChangeEvent<HTMLInputElement>) {
        const { value } = e.target;

        input.onChange(value);
        onChange?.(value);
      }

      function handleTextInputBlur(e: FocusEvent<HTMLInputElement>) {
        input.onBlur(e);
        onBlur?.(e);
      }

      return (
        <AutoComplete
          type={type}
          options={options}
          isError={error}
          noFoundMessage="Значение не найдено"
          handleAutoCompleteSelect={onSelect}
        >
          <TextInput
            {...input}
            id={input.name}
            placeholder={placeholder}
            error={error}
            value={`${input.value}`}
            clearable={clearable}
            disabled={disabled}
            onChange={handleAutoCompleteChange}
            onBlur={handleTextInputBlur}
            onClear={onClear}
            warning={warning}
            success={success}
          />
        </AutoComplete>
      );
    }}
  </Field>
);
